import angular, { IPromise } from "angular";
import { IFieldArray } from "AngularFormly";
import formUtilities from "../../../ui-formly/formUtilities";
import { IResponseStatus } from "../../server/query";

export interface FormSubmitArgs {
  model: unknown;
  formViewController: FormViewController;
}

export class FormViewController {
  static $inject = [];

  form!: angular.IFormController;
  httpPending: boolean = false;

  //bindings
  fields!: IFieldArray;
  model!: unknown;
  title!: string;
  onSubmit!: (args: FormSubmitArgs) => IPromise<void>;
  onCancel!: (args: FormSubmitArgs) => void;

  constructor() {}

  submit() {
    formUtilities.clearServerErrors(this.form);

    if (this.form.$valid) {
      this.httpPending = true;
      this.onSubmit({
        model: this.model,
        formViewController: this,
      }).finally(() => {
        this.httpPending = false;
      });
    }
  }

  cancel() {
    this.onCancel({
      model: this.model,
      formViewController: this,
    });
  }

  setApiErrors(responseStatus?: IResponseStatus) {
    formUtilities.setServiceStackServerErrors(
      responseStatus?.Errors ?? [
        {
          ErrorCode: "unknown",
          FieldName: "unknown",
          Message: "Unknown Error occurred",
        },
      ],
      this.form
    );
  }
}
